import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FreestarAdSlot from "@freestar/pubfig-adslot-react-component";
import { FREESTAR_PUBLISHER, FreestarPlacements } from "./freestar-placements";

interface FreestarSlotProps {
  placement: FreestarPlacements;
  slotId: string;
  // Out-of-page units should survive filter changes; in-page units should not.
  refreshOnSearch?: boolean;
}

// Remounting is how Freestar's component deletes and re-requests a slot, so the key follows the URL.
// The key settles one tick late because some pages rewrite the URL in a mount effect (e.g. the router
// lowercasing the path), which would otherwise mount, delete, and re-request the same slot back to back.
export function FreestarSlot({ placement, slotId, refreshOnSearch = true }: FreestarSlotProps) {
  const { pathname, search } = useLocation();
  const url = refreshOnSearch ? `${pathname}${search}` : pathname;
  const [settledUrl, setSettledUrl] = useState<string | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => setSettledUrl(url));
    return () => clearTimeout(timer);
  }, [url]);

  if (!settledUrl) return null;

  return <FreestarAdSlot key={settledUrl} publisher={FREESTAR_PUBLISHER} placementName={placement} slotId={slotId} />;
}
